import { useAnimatedNumber } from "../hooks/useAnimatedNumber";
import { fmtEUR } from "../lib/calculations";
import type { ComputedResults } from "../lib/types";

const COLOR_BG: Record<ComputedResults["scoreColor"], string> = {
  danger: "from-danger to-warning",
  warning: "from-warning to-warning",
  yellow: "from-warning to-success",
  successLight: "from-success/80 to-success",
  success: "from-success to-success",
};

interface Props {
  results: ComputedResults;
}

export function ScoreBanner({ results }: Props) {
  const animated = useAnimatedNumber(results.score, 1100);
  const cf = results.cashFlowMensuel;
  const phrase =
    cf > 200
      ? `Votre LMNP génère ${fmtEUR(cf, { sign: true })}/mois. Quelques optimisations sont encore possibles.`
      : cf >= 0
      ? `Votre LMNP s'autofinance presque (${fmtEUR(cf)}/mois). Marge à sécuriser.`
      : `Votre LMNP coûte ${fmtEUR(Math.abs(cf))}/mois. À corriger en priorité.`;

  return (
    <section
      className={`relative overflow-hidden bg-gradient-to-br ${COLOR_BG[results.scoreColor]} text-white`}
    >
      <div className="pointer-events-none absolute inset-0 opacity-20" style={{
        backgroundImage: "radial-gradient(circle at 20% 50%, white 0%, transparent 40%), radial-gradient(circle at 80% 80%, white 0%, transparent 40%)"
      }} />
      <div className="relative mx-auto max-w-6xl px-6 py-12 lg:px-12 lg:py-16">
        <div className="flex flex-col items-center gap-4 text-center">
          <p className="text-sm font-medium uppercase tracking-wider opacity-90">
            Votre score d'investissement
          </p>
          <div className="flex items-baseline gap-2">
            <span className="text-7xl font-extrabold tabular tracking-tight sm:text-8xl">
              {Math.round(animated)}
            </span>
            <span className="text-3xl font-bold opacity-80">/100</span>
          </div>
          <p className="text-2xl font-bold sm:text-3xl">{results.scoreLabel}</p>
          <p className="max-w-xl text-base opacity-95 sm:text-lg">{phrase}</p>
        </div>
      </div>
    </section>
  );
}
